export default __webpack_public_path__ + "static/media/projektant.15e908b3.png";